import './vue-flags';
import { createApp } from 'vue';
import { createVuetify } from 'vuetify/dist/vuetify.js';
import App from './App.vue';
import router from './router';

import 'vuetify/dist/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css';

const vuetify = createVuetify({
    theme: {
        defaultTheme: 'light',
    },
    display: {
        mobileBreakpoint: 'sm',
    },
});

const app = createApp(App);

app.use(router);
app.use(vuetify);

app.mount('#app');
